import { Badge } from "../ui/badge";
import { Radar } from "lucide-react";
import type { RescueCase } from "@io-spoke/contracts/rescue";

const severityClass = {
  info: "border-sky-400/30 bg-sky-500/10 text-sky-800 dark:text-sky-300",
  warning: "border-amber-400/30 bg-amber-500/10 text-amber-800 dark:text-amber-300",
  critical: "border-rose-400/30 bg-rose-500/10 text-rose-800 dark:text-rose-300",
};

function money(cents: number, currency: string) {
  return new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 0 }).format(cents / 100);
}

export function RescueCustomerSummary({ rescueCase }: { rescueCase: RescueCase }) {
  return <header className="border-b bg-gradient-to-br from-orange-500/5 via-card to-card px-5 py-5 sm:px-6">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <p className="flex items-center gap-2 text-xs font-medium text-orange-800 dark:text-orange-300"><Radar className="h-4 w-4" aria-hidden="true" />Customer rescue</p>
      <Badge variant="outline">Risk assessment {rescueCase.riskScore}/100</Badge>
    </div>
    <h3 className="mt-3 text-base font-semibold">Account context</h3>
    <p className="mt-1 break-words text-base font-medium">{rescueCase.title}</p>
    <div className="mt-4 grid gap-3 sm:grid-cols-[minmax(0,1fr)_auto]">
      <div className="rounded-lg border bg-card p-3"><p className="text-xs text-muted-foreground">The customer commitment</p><p className="mt-1 break-words text-sm leading-6">{rescueCase.promise}</p></div>
      <div className="rounded-lg border bg-card p-3"><p className="text-xs text-muted-foreground">Annual account value</p><p className="mt-1 text-xl font-semibold tabular-nums">{money(rescueCase.annualValueCents, rescueCase.currency)}</p></div>
    </div>
    <details className="mt-3"><summary className="min-h-11 cursor-pointer rounded py-3 text-sm font-medium outline-none focus-visible:ring-2 focus-visible:ring-ring">View assessment context</summary><p className="pb-2 text-sm leading-6 text-muted-foreground">{rescueCase.narrative}</p>
    {rescueCase.signals.length ? <div className="mt-4 grid gap-2 sm:grid-cols-2">{rescueCase.signals.map((signal) => <div key={signal.key} className={`min-w-0 rounded-md border px-3 py-2 ${severityClass[signal.severity]}`}><p className="text-xs">{signal.label}</p><p className="mt-1 break-words text-sm font-semibold">{signal.value}</p></div>)}</div> : null}
    </details>
  </header>;
}
